/* eslint-disable */
import { APPNAME, APPOWNER } from '../utils/utils.constants';
import { FeatureItem } from './subcomponents/FeatureItem.component';
import { Hrseparator } from './subcomponents/Hrseparator';
import { IoIosArrowForward } from "react-icons/io";
import { discoverIcon, newsIcon, registrationIcon } from './subcomponents/Icons';
import heroImage from '../assets/images/hero-image.png';
import { NavLink } from 'react-router-dom';
import { routes } from '../utils/utils.routes';
import { Colors } from '../utils/utils.colors';
import { HeroCarousel } from './HeroCaroussel';
import React from 'react';

const ArrowForward = IoIosArrowForward as any;

export const HeroSection: React.FC = () => {

    const [items, setItems] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState<boolean>(true);

    React.useEffect(() => {
        import("../utils/api").then(({ apiGet }) =>
            apiGet("/contents", { limit: 3 }).then((d) => { setItems(d.rows || []); setLoading(false) }).catch(() => { setItems([]); setLoading(false) })
        );
    }, []);

    return (
        <main
            className="wp-block-group alignfull site-content is-style-default is-layout-flow wp-container-core-group-is-layout-2bb4a3bc wp-block-group-is-layout-flow"
            style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingRight: 0, paddingBottom: 0, paddingLeft: 0 }}>
            {loading || items.length === 0 ? (
                <>
                    <div className="wp-block-cover alignwide is-style-default" style={{ borderRadius: '0px', paddingTop: 'var(--wp--preset--spacing--small)', paddingRight: '0px', paddingBottom: 'var(--wp--preset--spacing--small)', paddingLeft: '0px' }}>
                        <span
                            aria-hidden="true"
                            className="wp-block-cover__background has-background-dim-100 has-background-dim wp-block-cover__gradient-background has-background-gradient has-black-primary-gradient-background">
                        </span>

                        <img
                            className="wp-block-cover__image-background intrinsic-ignore"
                            src={heroImage}
                            alt=''
                            style={{ objectPosition: '35% 37%' }}
                            data-object-fit="cover"
                        />

                        <div className="wp-block-cover__inner-container is-layout-flow wp-block-cover-is-layout-flow">
                            <div className="wp-block-group is-style-default has-global-padding is-layout-constrained wp-container-core-group-is-layout-e73fcf31 wp-block-group-is-layout-constrained"
                                style={{ paddingRight: '5%', paddingLeft: '5%' }}>

                                <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-28f84493 wp-block-columns-is-layout-flex">
                                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{}}>
                                        <div style={{ height: '60px' }} aria-hidden="true" className="wp-block-spacer" />

                                        <div className="wp-block-group" style={{ paddingTop: 'var(--wp--preset--spacing--50)', paddingBottom: 'var(--wp--preset--spacing--50)' }}>
                                            <h1 className="wp-block-heading has-text-align-left has-white-color has-text-color has-max-60-font-size page-section-header__title text-white"
                                                style={{ lineHeight: '1.2' }}>
                                                {APPOWNER} <br />
                                                <span style={{ color: Colors.whiteColor }} className='page-section-header__title text-white'> {APPNAME} </span>
                                            </h1>

                                            <p className="has-text-align-left">
                                                Nous sommes l’Université Libre des Pays des Grands Lacs ( ULPGL ), une université Chrétienne des Eglises Protestantes des Pays de Grands Lacs, <br />  privée et agréée par le Gouvernement congolais
                                            </p>
                                            <Hrseparator />
                                            <p className="has-text-align-left">
                                                L’ULPGL est issue de l’Institut supérieur de théologie protestante créé en 1985 et transformé en université (ULPGL) en 1990. <br /> Elle est localisée dans la ville de Goma, en province du Nord-Kivu, en République démocratique du Congo. Notre devise est : Foi‑Science‑Action
                                            </p>

                                            <div className="wp-block-buttons is-content-justification-left is-layout-flex wp-container-core-buttons-is-layout-fc4fd283 wp-block-buttons-is-layout-flex">
                                                <div className="wp-block-button wpz-alt-button">
                                                    <NavLink
                                                        className="wp-block-button__link wp-element-button"
                                                        style={{ flex: 1, display: "flex", flexDirection: "row", alignContent: "center", alignItems: "center", maxWidth: 230 }}
                                                        to={routes.ABOUT}
                                                    >
                                                        En Savoir plus
                                                        <ArrowForward size={20} style={{ marginLeft: 20 }} />
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ height: '8vh' }} aria-hidden="true" className="wp-block-spacer"></div>
                        </div>
                    </div>
                    <div className="wp-block-group alignwide is-style-default has-primary-background-color has-background has-global-padding is-layout-constrained- wp-block-group-is-layout-constrained">

                        <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-28f84493 wp-block-columns-is-layout-flex mx-auto padding-x">
                            <div className="col-md-4 d-flex">
                                <FeatureItem
                                    icon={registrationIcon}
                                    title="Inscription"
                                    description="Prêt à franchir une nouvelle étape dans votre parcours académique ?"
                                    linkText="Demander une inscription"
                                    linkHref="https://uat.ulpgl.net/UATApplication/"
                                    linkTarget="_blank"
                                />
                            </div>

                            <div className="col-md-4 d-flex">
                                <FeatureItem
                                    icon={newsIcon}
                                    title="Dernières nouvelles"
                                    description={`Tout ce qui se passe à ${APPOWNER}, les événements à venir, les annonces importantes et les histoires inspirantes de nos étudiants et de notre communauté.`}
                                    linkText="Parcourir les actualités"
                                    linkHref={routes.ARTICLES}
                                />
                            </div>

                            <div className="col-md-4 d-flex">
                                <FeatureItem
                                    icon={discoverIcon}
                                    title="Découvrez-nous"
                                    description="Faites un tour de nos campus, découvrez nos programmes et voyez par vous-même pourquoi nous sommes l'université idéale pour vous."
                                    linkText="En savoir plus"
                                    linkHref={routes.ABOUT}
                                    isLast
                                />
                            </div>

                        </div>
                        <div style={{ height: '60px' }} aria-hidden="true" className="wp-block-spacer"></div>
                    </div>
                </>
            ) : <HeroCarousel articles={items} isLoading={false} />}
        </main>
    );
};